<script>

    import { toast } from 'bulma-toast'
    import { userStore, usersStore, adminStore, modalStore } from '../stores'

    import UsersService from '../$services/users.service'

    import Switch from '../$components/switch.svelte'

    import Form from '../$components/form.svelte'

    import InputText from '../$components/input.text.svelte'
    import Select from '../$components/select.svelte'

    import Button from '../$components/button.svelte'
    import ButtonSave from '../$components/button.save.svelte'

    let data = {
        role: $userStore.role,
        corporate: $userStore.corporate,
        firstName: $userStore.firstName,
        lastName: $userStore.lastName,
        phone: $userStore.phone,
        status: $userStore.status,
        hidePrices: $userStore.hidePrices || false,
        coverageCost: $userStore.coverageCost || false,
        coverageSpecial: $userStore.coverageSpecial || false,
    }

    let loading = false

    let changeEmail = false
    let changePassword = false

    async function updateUser() {

        if(!changeEmail)
            delete data.email

        if(!changePassword)
            delete data.password
        
        loading = true
        const resp = await UsersService.updateUser($userStore._id, data)
        loading = false
    
        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})
    
        userStore.set(resp.data)
        usersStore.replace(resp.data)
        toast({message: 'Usuario actualizado', type: 'is-success'})

        modalStore.close()

        delete data.email
        delete data.password
    }

</script>

<Form on:submit={updateUser} {loading}>
    
    <div class="columns">
        <div class="column">
            <Select bind:value={data.status}
                label="Estatus"
                options={[
                    {value: 'enabled', text: 'Activar'},
                    {value: 'disabled', text: 'Bloquear'}
                ]}
            />
        </div>
        {#if $adminStore.role === 'admin'}
            <div class="column">
                <Select bind:value={data.role}
                    label="Rol"
                    options={[
                        {value: 'user', text: 'Usuario'},
                        {value: 'adviser', text: 'Asesor'},
                        {value: 'admin', text: 'Administrador'},
                        {value: 'driver', text: 'Conductor'},
                        {value: 'almacen', text: 'Almacen'},
                    ]}
                />
            </div>
        {/if}
    </div>

    <div class="columns">
        <div class="column">
            <InputText bind:value={data.firstName} label="Nombre" placeholder="Nombre" />
        </div>
        <div class="column">
            <InputText bind:value={data.lastName} label="Apellido" placeholder="Apellido" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <InputText bind:value={data.corporate} label="Corporación" placeholder="Corporación" required={false} />
        </div>
    </div>
    
    <div class="columns">
        <div class="column">
            <InputText bind:value={data.phone} label="Teléfono" placeholder="Teléfono" />
        </div>
    </div>

    <div>
        <Switch bind:checked={data.hidePrices} label="Ocultar precios" />
    </div>

    <div>
        <Switch bind:checked={data.coverageCost} label="Cobertura con costo" />
    </div>

    <div>
        <Switch bind:checked={data.coverageSpecial} label="Cobertura especial" />
    </div>

    <div>
        <Switch bind:checked={changeEmail} label="Cambiar correo" />
    </div>

    {#if changeEmail}
        <div class="columns">
            <div class="column">
                <InputText bind:value={data.email} label="Correo" placeholder="Correo" />
            </div>
        </div>
    {/if}
    
    <div>
        <Switch bind:checked={changePassword} label="Cambiar contraseña" />
    </div>
    
    {#if changePassword}
        <InputText bind:value={data.password} label="Contraseña" placeholder="Contraseña" />
    {/if}
    
    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <Button on:click={modalStore.close} text="Cancelar" icon="ban" />
        <ButtonSave icon="edit" text="Actualizar" />
    </div>

</Form>